import { render, staticRenderFns } from "./exhibitionSummary.vue?vue&type=template&id=1d63fc02&scoped=true"
import script from "./exhibitionSummary.vue?vue&type=script&lang=js"
export * from "./exhibitionSummary.vue?vue&type=script&lang=js"
import style0 from "./exhibitionSummary.vue?vue&type=style&index=0&id=1d63fc02&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d63fc02",
  null
  
)

export default component.exports